module.exports = __webpack_public_path__ + "8a39880abee6b12de17590ab91792c4a.svg";